import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content.types";
import { EngagementContent } from "PFApp/components/card_tx/content/engagement_content";
import { EngagementFooter } from "PFApp/components/card_tx/footer/engagement_footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type EngagementVariantProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "isDraft" | "numberOfRoles" | "handleShare" | "handleRefetchActivities"
>;

export const EngagementVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  numberOfRoles,
  handleShare,
  handleRefetchActivities
}: EngagementVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    activity,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={activity.private} isDraft={isDraft} />
      <EngagementContent activity={activity} isFeed={isFeed} />
      <EngagementFooter numberOfRoles={numberOfRoles} />
    </>
  );
};
